import * as Sentry from '@sentry/angular';
import { EventHint } from '@sentry/angular';

export function filterSentryEvent(event: Sentry.ErrorEvent, hint?: EventHint): Sentry.ErrorEvent {
  const values = event?.exception?.values || [];

  for (const exception of values) {
    if (
      exception.value.includes(`Non-Error promise rejection captured with value`) ||
      exception.value.includes(`Non-Error exception captured with keys`) ||
      exception.value.includes(`Object captured as exception with keys`) ||
      exception.value.includes(`captured as promise rejection`) ||
      exception.value.includes(`Timeout has occurred`) ||
      exception.value.includes(`The remote server machine does not exist or is unavailable`) ||
      exception.value.includes(`NetworkError`) ||
      exception.value.includes(`network error`) ||
      exception.value.includes(`NETWORK_ERR`) ||
      exception.value.includes(`Server returned code 502 with body`) ||
      exception.value.includes(`Server returned code 504 with body`) ||
      exception.value.includes(`Server returned code 503 with body`) ||
      exception.value.includes(`Server returned code 400 with body`) ||
      exception.value.includes(`Error in input stream`) ||
      exception.value.includes(`Http failure`) ||
      exception.value.includes(`Failed to fetch`) ||
      exception.value.includes(`No error message`) ||
      exception.value.includes(`_avast_submit`) ||
      exception.value.includes(`change_ua`) ||
      exception.value.includes(`_logicalFormForControl`) ||
      exception.value.includes(`_convertKeyframesToObject`) ||
      exception.value.includes(`ChunkLoadError`) ||
      exception.value.includes(`Load failed`) ||
      exception.value.includes(`SecurityError`) ||
      exception.value.includes(`The operation is insecure`) ||
      exception.value.includes(`Java exception was raised during method invocation`) ||
      exception.value.includes(`Java object is gone`) ||
      exception.value.includes(`Error: not implemented`) ||
      exception.value.includes(`Notifications are not allowed for this application`) ||
      exception.value.includes(`plugin is not implemented on ios`) ||
      exception.value.includes(`Impossibile comunicare con un’applicazione di supporto`) ||
      exception.value.includes(`Failed to start the audio device`) ||
      exception.value.includes(`Unable to display URL`) ||
      exception.value.includes(`while retrieving PDF`) ||
      exception.value.includes(`PDFViewerApplication`) ||
      exception.value.includes(`assets/viewer`) ||
      exception.value.includes(`assets/pdf`) ||
      exception.value.includes(`Invalid call to runtime.sendMessage`) ||
      exception.value.includes(`window.webkit.messageHandlers`) ||
      exception.value.includes(`requestAnimationFrame`) ||
      exception.value.includes(`queueMicrotask is not defined`)
    )
      return null;

    const topLevelFrames = (event as any).stacktrace?.frames || [];
    const stackTraceframes = exception.stacktrace?.frames || [];

    const allFrames = [...topLevelFrames, ...stackTraceframes];

    for (const frame of allFrames) {
      if (
        frame.module?.includes('assets/pdf') ||
        frame.filename?.includes('assets/pdf') ||
        frame.module?.includes('assets/viewer') ||
        frame.filename?.includes('assets/viewer') ||
        frame.module?.includes('assets/op-chaining-support') ||
        frame.filename?.includes('assets/op-chaining-support') ||
        frame.module?.includes('ngx-extended-pdf-viewer') ||
        frame.filename?.includes('ngx-extended-pdf-viewer') ||
        frame.module?.includes('lottie-web') ||
        frame.filename?.includes('lottie-web') ||
        frame.module?.includes('@intercom/messenger-js-sdk') ||
        frame.filename?.includes('@intercom/messenger-js-sdk') ||
        frame.module?.includes('tinymce') ||
        frame.filename?.includes('tinymce') ||
        frame.module?.includes('h0.js') ||
        frame.filename?.includes('h0.js') ||
        frame.function?.includes('openPDF') ||
        frame.function?.includes('onPdfJsInit')
      )
        return null;
    }
  }

  if (event) {
    event.extra = {
      ...event?.extra,
      hintObj: hint,
      exceptionObj: event?.exception?.values || [],
      topLevelFramesObj: (event as any).stacktrace?.frames || [],
      additionalData: {
        message: event?.message,
        logentry: event?.logentry,
        logger: event?.logger,
        request: event?.request,
        transaction: event?.transaction,
        modules: event?.modules,
        fingerprint: event?.fingerprint,
        breadcrumbs: event?.breadcrumbs,
        contexts: event?.contexts,
        tags: event?.tags,
        spans: event?.spans,
        measurements: event?.measurements,
        debug_meta: event?.debug_meta,
        transaction_info: event?.transaction_info,
        threads: event?.threads,
      },
    };
  }

  return event;
}
